export default __webpack_public_path__ + "static/media/amparo-arte-10.6ad38a74.webp";